export const interestLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 111.68841343000003,
        ymin: -34.99775260000001,
        xmax: 123.63228824299995,
        ymax: -17.30794632300001,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'interestid',
            type: 'esriFieldTypeInteger',
            alias: 'interestid',
            editable: true,
            nullable: true
        },
        {
            name: 'subject',
            type: 'esriFieldTypeString',
            alias: 'subject',
            editable: true,
            nullable: true,
            length: 256
        },
        {
            name: 'polygonids',
            type: 'esriFieldTypeString',
            alias: 'polygonids',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'polylineids',
            type: 'esriFieldTypeString',
            alias: 'polylineids',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'beneficiarylots',
            type: 'esriFieldTypeString',
            alias: 'beneficiarylots',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'burdenlots',
            type: 'esriFieldTypeString',
            alias: 'burdenlots',
            editable: true,
            nullable: true,
            length: 10024
        },
        {
            name: 'description',
            type: 'esriFieldTypeString',
            alias: 'description',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'tenure',
            type: 'esriFieldTypeString',
            alias: 'tenure',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'interestcode',
            type: 'esriFieldTypeString',
            alias: 'interestcode',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'portion',
            type: 'esriFieldTypeString',
            alias: 'portion',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
